/**
 * SettingsCardSub — right-rail toggles for a Subcategory.
 *
 *   • Active            → subcategory_is_active
 *   • Mark as new       → subcategory_is_new
 *   • Dark mode         → subcategory_is_dark_mode
 *   • Quick Tap subcategory → subcategory_is_quick_tap
 */
import React from 'react';
import RailCard, { RailCardHead } from '../../redesign/edit/RailCard';

const ROWS = [
  { name: 'subcategory_is_active',    label: 'Active' },
  { name: 'subcategory_is_new',       label: 'Mark as new' },
  { name: 'subcategory_is_dark_mode', label: 'Dark mode display' },
  { name: 'subcategory_is_quick_tap', label: 'Quick Tap subcategory' },
];

function CompactToggle({ checked, onChange, name }) {
  return (
    <label
      style={{
        position: 'relative',
        width: 36,
        height: 20,
        flexShrink: 0,
        cursor: 'pointer',
        display: 'inline-block',
        transform: 'scale(0.92)',
      }}
    >
      <input
        type="checkbox"
        name={name}
        checked={!!checked}
        onChange={onChange}
        style={{
          position: 'absolute',
          width: 1,
          height: 1,
          padding: 0,
          margin: -1,
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          border: 0,
        }}
      />
      <span
        aria-hidden
        style={{
          position: 'absolute',
          inset: 0,
          borderRadius: 999,
          background: checked ? '#75A293' : '#E8E0CF',
          transition: 'background 160ms ease',
        }}
      />
      <span
        aria-hidden
        style={{
          position: 'absolute',
          top: 2,
          left: checked ? 18 : 2,
          width: 16,
          height: 16,
          borderRadius: '50%',
          background: '#FFFFFF',
          boxShadow: '0 1px 3px #2C3E5040',
          transition: 'left 160ms ease',
        }}
      />
    </label>
  );
}

function Row({ row, value, onChange, isLast }) {
  return (
    <div
      className="flex items-center justify-between"
      style={{
        padding: '10px 0',
        borderBottom: isLast ? 'none' : '1px solid #ECE3D2',
        gap: 12,
      }}
    >
      <div style={{ minWidth: 0, flex: 1 }}>
        <div className="text-navy" style={{ fontSize: 13, fontWeight: 600 }}>
          {row.label}
        </div>
        <div className="text-text-muted" style={{ marginTop: 1, fontSize: 10.5 }}>
          <span className="font-mono">{row.name}</span>
        </div>
      </div>
      <CompactToggle
        name={row.name}
        checked={!!value}
        onChange={onChange}
      />
    </div>
  );
}

export default function SettingsCardSub({ state, onChange }) {
  const enabledCount = ROWS.reduce(
    (n, r) => n + (state[r.name] ? 1 : 0),
    0,
  );

  return (
    <RailCard
      variant="settings"
      head={({ open, toggle }) => (
        <RailCardHead
          title="Settings"
          variant="settings"
          open={open}
          onToggle={toggle}
          pill={
            <span
              className="font-mono text-text-muted bg-cream border border-sand"
              style={{
                fontSize: 11,
                padding: '2px 8px',
                borderRadius: 999,
                whiteSpace: 'nowrap',
              }}
            >
              {enabledCount}/{ROWS.length}
            </span>
          }
        />
      )}
    >
      <div style={{ padding: '6px 18px 14px' }}>
        {ROWS.map((row, i) => (
          <Row
            key={row.name}
            row={row}
            value={state[row.name]}
            onChange={(e) => onChange(row.name, e.target.checked)}
            isLast={i === ROWS.length - 1}
          />
        ))}
      </div>
    </RailCard>
  );
}
